import type { ComponentType } from "react";
import type { AssistantContentRef, AssistantContentType } from "../../../../api/types/assistantTypes";
import DataImportPanel from "./data-import/DataImportPanel";

interface PanelProps {
  contentId: string;
  isExpanded: boolean;
  onToggleExpand: () => void;
  onClose: () => void;
}

const panelComponents: Record<AssistantContentType, ComponentType<PanelProps>> = {
  DataImport: DataImportPanel,
};

interface Props {
  content: AssistantContentRef;
  isExpanded: boolean;
  onToggleExpand: () => void;
  onClose: () => void;
}

const ContentPanel = ({ content, isExpanded, onToggleExpand, onClose }: Props) => {
  const Panel = panelComponents[content.type];
  return <Panel contentId={content.id} isExpanded={isExpanded} onToggleExpand={onToggleExpand} onClose={onClose} />;
};

export default ContentPanel;
